<template>
    <div class="my-order" ref="container">
        <div class="list">
            <div class="item notice-item" v-for="item in NoticeList" :key="item.id">
                <div class="notice-title">{{item.title}}</div>
                <div class="notice-content">{{item.content}}</div>
                <div class="notice-bottom">{{item.user}} {{item.add_time}}</div>
            </div>
        </div>
        <div class="noCart" v-if="NoticeList.length === 0 && page > 1">
            <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
        </div>
        <Loading :loaded="loaded" :loading="loading"></Loading>
    </div>
</template>
<script>
    import { getLuckyNoticeList } from "@api/user";
    import Loading from "@components/Loading";
    import { mapGetters } from "vuex";

    const NAME = "userNotice";

    export default {
        name: NAME,
        data() {
            return {
                page: 1,
                loaded: false,
                loading: false,
                NoticeList: []
            };
        },
        components: {
            Loading
        },
        computed: mapGetters(["userInfo"]),
        methods: {
            getLuckyNoticeList() {
                if (this.loading || this.loaded) return;
                this.loading = true;
                const { page } = this;
                getLuckyNoticeList({page}).then(res => {
                    this.NoticeList = this.NoticeList.concat(res.data.list);
                    this.page++;
                    this.loaded = res.data.lastpage > 0;
                    this.loading = false;
                });
            }
        },
        mounted() {
            this.getLuckyNoticeList();
            this.$scroll(this.$refs.container, () => {
                !this.loading && this.getLuckyNoticeList();
            });
        }
    };
</script>

<style scoped>
    .notice-item{padding:14px}
    .notice-title{font-size: 16px;font-weight: 600;text-align: center}
    .notice-content{margin-top: 14px;margin-bottom: 14px;}
    .notice-bottom{text-align: right;color:#999c9e}
    .noCart {
        margin-top: 0.17rem;
        padding-top: 0.1rem;
    }

    .noCart .pictrue {
        width: 4rem;
        height: 3rem;
        margin: 0.7rem auto 0.5rem auto;
    }

    .noCart .pictrue img {
        width: 100%;
        height: 100%;
    }
</style>
